module.exports = __webpack_public_path__ + "img/showbill4.ee56f469.jpg";